// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__12Jq5","text":"Error_text__2GK4p","button":"Error_button__1IjL9"};